export enum ActionTypes {
    // FETCH_CONTRACT_KIND_LIST = 'FETCH_CONTRACT_KIND_LIST',
    FETCH_CONTRACT_LIST = 'FETCH_CONTRACT_LIST',
    // CONTRACT_VIEW = 'CONTRACT_VIEW',
}
